import React from 'react';

// Styles & Assets
import styles from './FilterColumnsUsersDialog.module.css';

// Language
import { useTranslation } from 'react-i18next';

const FilterColumnsUsersDialog: React.FC<{
    modalShow: React.Dispatch<React.SetStateAction<boolean>>,
    children: React.ReactNode
}> = ({ modalShow, children}) => {

    const { t } = useTranslation();

    return (
        <div className='dialog'>
            <div className={styles.content}>
                <h1 className={`${styles.selectColumnsh1} dialogTitle`}>{t('select_data')}</h1>
                {children}
            </div>
            <div className={styles.buttonWrapper}>
                <button onClick={() => modalShow(false)} className={`${styles.buttonClose} button`}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default FilterColumnsUsersDialog;